module.exports = __webpack_public_path__ + "img/8.f96e4105.jpg";